module.exports = __webpack_public_path__ + "img/pocket-1_jp.f3f1643.jpg";